import { useApp } from '../../../common/AppProvider';
import { translations } from '../../../translations/translations';
import type { MentionSuggestion } from './MarkdownField';

type Props = {
    items: MentionSuggestion[];
    command: (item: MentionSuggestion) => void;
};

const MentionList = ({ items, command }: Props) => {
    const { language } = useApp();

    return (
        <div className="tiptap-mention-dropdown-menu">
            {items.length ? (
                items.map((item) => (
                    <button
                        className="tiptap-mention-dropdown-item"
                        type="button"
                        key={item.id}
                        onClick={() => command(item)}
                    >
                        <div>{item.label}</div>
                        <div className="tiptap-mention-description-text">
                            {item.description === '' ? '---' : item.description}
                        </div>
                    </button>
                ))
            ) : (
                <div className="tiptap-mention-dropdown-item no-result">
                    {translations[language].COMMON_no_results}
                </div>
            )}
        </div>
    );
};

export default MentionList;
